import { LitElement, html } from 'lit-element';
import { isXs } from 'lm-ui-kit/src/utils/response-query';
import cn from 'clsx';
import { styles } from './uc-footer-menu-toggle.styles';
import '../uc-icon/uc-icon.define';
import { back } from '../icons/back';

export const props = {
  state: {
    reflect: true,
    converter: {
      fromAttribute: value => value === 'true',
      toAttribute: value => value.toString(),
    },
  },
  columns: { type: Number },
};

export class UcFooterMenuToggle extends LitElement {
  static get styles() {
    return styles;
  }

  static get properties() {
    return props;
  }

  constructor() {
    super();

    this.state = false;
    this.columns = 1;
  }

  _menuClick() {
    if (isXs()) {
      this.state = this.state === false;
    }
  }

  render() {
    return html`
      <div class="accordion">
        <uc-button class="name-button">
          <button @click=${() => this._menuClick()}>
            <slot name="name" class="name"></slot>
          </button>
        </uc-button>
        <uc-button class="icon-container">
          <button class="icon-button" @click=${() => this._menuClick()}>
            <uc-icon class="icon"> ${back} </uc-icon>
          </button>
        </uc-button>
      </div>

      <div class=${cn('menu-container', { hide: !this.state }, { columns: this.columns !== 1 })}>
        <slot class="menu"></slot>
      </div>
    `;
  }
}
